import { useLocation, useParams } from "react-router";
import {
    Container,
    Content,
    IconInstalledBase,
    PageTitle,
    Root,
    SwitchContainer,
} from "./InstalledBasePage.styles";
import React, { useState } from "react";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { BusinessUnit } from "../../../../explorer/types/SpareParts/BusinessUnit";
import ServiceProvider from "../../../configuration/ServiceProvider";
import InstalledBaseAccordion from "./InstalledBaseAccordion/InstalledBaseAccordion";
import { Box, Switch, Typography } from "@mui/material";
import InstalledBaseImage from "./InstalledBaseImage/InstalledBaseImage";
import BreadcrumbComponent from "../../../components/Breadcrumb/BreadcrumbComponent";
import useBrands from "../../../../explorer/hooks/useBrands";
import InstalledBaseSkeleton from "./InstalledBaseSkeleton";
import AppIconsError from "../../../components/AppIcons/AppIconsError";
import { StyleguideSavioColors } from "../../../configuration/themeSettings";

const InstalledBasePage = () => {
    const [businessUnits, setBusinessUnits] = React.useState<BusinessUnit[]>(
        []
    );

    const location = useLocation();
    const brand = useBrands().currentBrandUrl;
    const { customerSiteCode } = useParams();

    const [loading, setLoading] = useState<boolean>(true);

    const { t } = useTranslation();

    const [expandedAll, setExpandedAll] = React.useState(false);

    React.useEffect(() => {
        setLoading(true);
        ServiceProvider.SpareParts.getBusinessUnits(brand, customerSiteCode!)
            .then((result) => {
                setBusinessUnits(result);
                setLoading(false);
            })
            .catch((e) => console.error(e));
    }, [location]);

    const handleToggleAll = () => {
        setExpandedAll(!expandedAll);
    };

    return (
        <Root>
            <BreadcrumbComponent />

            <Container>
                <PageTitle>
                    <IconInstalledBase /> {t("common.homepage.installedBase")}
                </PageTitle>
                <InstalledBaseImage />

                {/** switch button */}
                <SwitchContainer>
                    <Switch checked={expandedAll} onChange={handleToggleAll} />
                    {t("common.homepage.expandall")}
                </SwitchContainer>

                <Content>
                    {loading ? (
                        <InstalledBaseSkeleton />
                    ) : businessUnits.length > 0 ? (
                        businessUnits.map((businessUnit: BusinessUnit, idx:number) => (
                            <InstalledBaseAccordion
                                key={businessUnit.name}
                                expandedAll={expandedAll}
                                businessUnit={businessUnit}
                                idx={idx}
                            />
                        ))
                    ) : (
                        <Box>
                            <Typography
                                variant="h5"
                                color={StyleguideSavioColors.text.grayTitles}
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"center"}
                            >
                                {t("common.spareparts.noEquipment")}
                            </Typography>
                        </Box>
                    )}
                </Content>
            </Container>
        </Root>
    );
};

export default InstalledBasePage;
